'use client'
import { type FC, memo } from 'react'
import { useRouter } from 'next/navigation'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import { mq, vw, presets } from '@/styles'
// import { Lottie } from './Lottie'

type Props = {}

export const MainNotFoundPage:FC<Props> = memo(() => {
  const { t } = useTranslator()
  const { push } = useRouter()

  const onClick = () => {
    push('/')
  }

  return (
    <Main>
      <Section>
        <hgroup>
          {/* <Lottie name='404' isActive={true} /> */}
          <h1>{typeof t === 'function' ? t('page_not_found.title') : ''}</h1>
          <p>{typeof t === 'function' ? t('page_not_found.description') : ''}</p>
          <button onClick={onClick}>{t('page_not_found.goback_homepage')}</button>
        </hgroup>
      </Section>
    </Main>
  )
})

const Main = styled.main`
  flex-grow: 2;
  overflow-x: hidden;
  padding: 0;
  position: relative;

  ${mq.greaterThan('tablet')} {
    overflow-x: inherit;
  }
`

const Section = styled.section`
  grid-column: 1 / span 6;
  padding: ${vw(50, 'mobile')} ${vw(20, 'mobile')};
  align-items: center;
  margin-bottom:${vw(50, 'mobile')} ;

  ${mq.greaterThan('tablet')} {
    padding: ${vw(50, 'tablet')} ${vw(20, 'tablet')};
    margin-bottom:${vw(50, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    grid-column: 5 / span 4;
    padding: ${vw(60, 'desktop')} 0;
    margin-bottom:${vw(60, 'desktop')} ;
  }

  ${mq.greaterThan('desktop')} {
    padding: 60px 0;
    margin-bottom: 60px;
  }

  ${mq.greaterThan('container')} {
    margin: 0 auto;
    max-width: 1650px;
  }

  button {
    color: var(--color-background);
    margin-top: ${vw(60, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-top:${vw(60, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-top:${vw(30, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-top: 30px;
    }
  }

  h1, p {
    padding: 15px;
    text-align: center;
  }

  h1 {
    ${presets.font26()}
    color: var(--color-text);
  }

  p {
    ${presets.font18()}
  }
`
